import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';

const lazy = {
    JobRecommendationsPage: lazyLoad(async () => {
        const { JobRecommendationsPage } = await import('./JobRecommendations');

        return { default: JobRecommendationsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.dashboard.job-recommendations.headline',
        page: lazy.JobRecommendationsPage,
        path: '/job-recommendations',
    },
];
